import React, { useState, useEffect } from 'react';

import { Accordion, Card, ListGroup, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faBan } from '@fortawesome/free-solid-svg-icons';

import Image from '../../../../../../../core-components/Image';
import CustomCounter from '../../../../../../../core-components/CustomCounter';

import {
  PLAIN_CHECK_ICONS,
  CHECKS_LIMIT,
  COURT_OPTIONS_FOR_ADDON_CONFIG
} from '../../../../../../../utils/commonConstant';
import { convertToIndianNumeration } from '../../../../../../../utils/utilities';
import styles from './Court.module.scss';

function Court(props) {
  const { values, onValueChange, pDetails } = props;

  const [courtCount, setCourtCount] = useState(0);
  const [valueCheckCount, setValueCheckCount] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState(null);

  useEffect(() => {
    if (pDetails) {
      setCourtCount(pDetails.length);
    }
  }, [pDetails]);

  const handleValueCheckCountChange = (value) => {
    if (value > valueCheckCount) {
      setCourtCount((prevCount) => prevCount + 1);
      setValueCheckCount(value);
    } else if (value < valueCheckCount) {
      setCourtCount((prevCount) => prevCount - 1);
      setValueCheckCount(value);
    }
  };

  const handleAnyConfigChange = (value) => {
    onValueChange('any', value);
  };

  const handleCourtCheckConfigChange = (event) => {
    const arr = [...values.config];

    if (event.target.checked) {
      setCourtCount((prevCount) => prevCount + 1);
      arr.push(event.target.value);
    } else {
      setCourtCount((prevCount) => prevCount - 1);
      arr.splice(arr.indexOf(event.target.value), 1);
    }

    onValueChange('config', arr);
  };

  const decoratedOnClick = (eventKey = 0) => {
    if (eventKey === activeAccordion) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(eventKey);
    }
  };

  return (
    <div className={styles.addonsContainer}>
      <Accordion>
        <Card className={styles.addonsContainerCard}>
          <Accordion.Toggle
            as={Card.Header}
            eventKey='0'
            className={styles.addonsContainerHeader}
            onClick={() => decoratedOnClick(0)}
          >
            <div>
              <span className={styles.iconContainer}>
                <FontAwesomeIcon icon={faPlusCircle} color='#389E0D' className={styles.plusIcon} />
                <FontAwesomeIcon
                  icon={PLAIN_CHECK_ICONS['court'] ? PLAIN_CHECK_ICONS['court'].icon : faBan}
                  color='rgba(39, 85, 254, 0.5)'
                  style={{ fontSize: '18px' }}
                />
              </span>
            </div>
            <div className={styles.headingRightContainer}>
              <span>{props?.heading}</span>
              <div className={styles.headingRight}>
                <span className={styles.startFrom}>
                  {'Starts from '}
                  <span className={styles.rupee}>&#8377;</span>
                  {convertToIndianNumeration(props?.price)}
                </span>
                {activeAccordion === 0 ? (
                  <Image name={'UpAngle.svg'} svg={'UpAngle.svg'} />
                ) : (
                  <Image name={'DownAngle.svg'} svg={'DownAngle.svg'} />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='0'>
            <Card.Body className={styles.cardBody}>
              <ListGroup className={styles.listGroup}>
                {COURT_OPTIONS_FOR_ADDON_CONFIG.map((item, index) => {
                  return pDetails && !pDetails.includes(item.name) ? (
                    <ListGroup.Item className={styles.listGroupItem}>
                      <Form.Group controlId={`${item.id}`} className={styles.formGroup}>
                        <Form.Check
                          name={`${item.name}`}
                          id={`${item.id}`}
                          type='checkbox'
                          value={item.name}
                          checked={values.config.includes(item.name)}
                          disabled={
                            CHECKS_LIMIT.COURT - courtCount === 0 &&
                            !values.config.includes(item.name)
                          }
                          onChange={(e) => {
                            handleCourtCheckConfigChange(e);
                          }}
                          label={<span className={styles.label}>{`${item.label}`}</span>}
                        />
                      </Form.Group>
                    </ListGroup.Item>
                  ) : null;
                })}
              </ListGroup>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}

export default Court;
